import { DropDown } from '@components/core-ui/form-elements/DropDown';
import Dots from '@components/icons/Dots.svg';
import { formatCentsPrice } from '@helpers/formatCentsPrice';
import { useModalContext } from '@providers/ModalProvider';
import { GetBillingAccountResponseDto } from 'app/API';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useState } from 'react';
import { TextButtonLarge } from '@components/core-ui/form-elements/buttons/Button/variations/TextButtonLarge';
import { Wrapper } from './styles/Wrapper';
import { DotsButton } from '@pages/User/BillingAccountDetailsPage/components/SubscriptionsWrapper/Cards/ActiveCard/styles/DotsButton';

type TProps = {
  className?: string;
  billingAccount?: GetBillingAccountResponseDto;
  reloadCards: () => void;
  canManageBillingAccount: boolean;
};

export const CreditBalanceCard = ({ className = '', billingAccount, canManageBillingAccount, reloadCards }: TProps) => {
  const { openModal } = useModalContext();
  const [showDropDown, setShowDropDown] = useState(false);

  const onTopUp = (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
    e.stopPropagation();
    if (!canManageBillingAccount) {
      return;
    }
    openModal(ModalNamesEnum.TopUpCreditBalance, {
      onSuccess: reloadCards,
    });
  };

  const balance = billingAccount?.currentBalance ?? 0;
  const description = <div className="balance">{formatCentsPrice(balance)}</div>;

  const renderOptions = () => {
    const dropDownOptions: {
      title: string;
      onClick: (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => void;
    }[] = [];
    if (canManageBillingAccount) {
      dropDownOptions.push({
        title: 'Add Funds',
        onClick: onTopUp,
      });
    }
    if (!dropDownOptions.length) {
      return;
    }
    return (
      <>
        <DotsButton
          className="dots-button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setShowDropDown(true);
          }}
        >
          <Dots />
        </DotsButton>
        {showDropDown ? <DropDown close={() => setShowDropDown(false)} options={dropDownOptions} /> : null}
      </>
    );
  };

  return (
    <Wrapper className={className}>
      <div className="content">
        <h2 className="title">Credit Balance</h2>
        {renderOptions()}
      </div>

      <div className="description">{description}</div>

      {canManageBillingAccount ? (
        <div className="buttonContainer">
          <TextButtonLarge onClick={onTopUp}>Add Funds</TextButtonLarge>
        </div>
      ) : null}
    </Wrapper>
  );
};
